import type { Feature } from './feature'

export class Selectors {
  /** @see {@link State.schema} */
  public readonly schema
  /** @see {@link State.loading} */
  public readonly isLoading

  constructor(feature: Feature) {
    this.schema = feature.state.project(state => state.schema)
    this.isLoading = feature.state.project(state => state.isLoading ?? false)
  }
}
